<script setup lang="ts">
import VFormInputWrapper
  from '@modules/forms/components/inputs/VFormInputWrapper/VFormInputWrapper.vue';

import type {
  VFormTextEditEmits,
  VFormTextEditProps,
} from './types';
import { useVFormTextEdit } from './composables';

const props = withDefaults(defineProps<VFormTextEditProps>(), {
  variables: () => ([]),
});
const emit = defineEmits<VFormTextEditEmits>();

const {
  editorElement,
  wordsCount,
  charactersCount,
} = useVFormTextEdit(props, emit);
</script>

<template>
  <VFormInputWrapper v-data-qa-auto-id="'VFormTextEdit'"
    :errors="errors"
    :hide-errors="hideErrors"
    :readonly="readonly"
    class="text-editor"
  >
    <label
      v-if="label"
      class="mb-2 block text-muted-color"
    >
      {{ label }}
    </label>
    <div ref="editorElement" />
    <div
      class="flex w-full
      justify-end gap-4 border-x border-b bg-gray-100
      p-2"
    >
      <span>
        Words: <span class="font-medium">{{ wordsCount }}</span>
      </span>
      <span>
        Characters: <span class="font-medium">{{ charactersCount }}</span>
      </span>
    </div>
  </VFormInputWrapper>
</template>

<style lang="scss" scoped>
.text-editor {
  :deep(.ck.ck-content) {
    padding: 1.5rem;
  }

  :deep(.ck.ck-button) {
    margin-right: 10px;
  }

  :deep(.variables-btn.ck-disabled) {
    display: none !important;
  }

  :deep(.variables-btn.ck-disabled+.ck-toolbar__separator) {
    display: none !important;
  }
}
</style>
